import { createFeature, createReducer } from '@ngrx/store';

import { locationDetailsWizardReducers } from './location-details-wizard.reducer';
import { locationDetailsWizardInitialState } from './location-details-wizard.state';

export const locationDetailsWizardFeature = createFeature({
    name: 'locationDetailsWizard',
    reducer: createReducer(locationDetailsWizardInitialState, ...locationDetailsWizardReducers),
});
